import { render, staticRenderFns } from "./rxhj.vue?vue&type=template&id=3fa489b7&scoped=true"
import script from "./rxhj.vue?vue&type=script&lang=js"
export * from "./rxhj.vue?vue&type=script&lang=js"
import style0 from "./rxhj.vue?vue&type=style&index=0&id=3fa489b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa489b7",
  null
  
)

export default component.exports